module.exports = __webpack_public_path__ + "img/singleLineTextEle.7411cc6c.svg";